module.exports = __webpack_public_path__ + "img/AOD2.a6a619f5.jpg";